import generatePassword from 'omgopass'

export function generatePass(): string {
  return generatePassword()
}
